export default {
  currentLegend: {}, // TODO INSERIR TODA A LEGENDA AQUI
  allLegend: [],
  loadingLegend: false,
  editLegend: false
}
